import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const UPDATE_OFFER_TITLE_MUTATION = gql`
mutation updateOfferTitle($documentVersion: DocumentVersionInput!, $title: String!) {
  quotes {
    modify(documentVersion: $documentVersion) {
      setTitle(title: $title) {
        id
      }
    }
  }
}
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateOfferTitleMutation extends Mutation<RootMutation> {
  document = UPDATE_OFFER_TITLE_MUTATION;
}
